'use client';

import CrispChat from './CrispChat';

const CRISP_WEBSITE_ID = process.env.NEXT_PUBLIC_CRISP_WEBSITE_ID;

if (!CRISP_WEBSITE_ID) {
  throw new Error('NEXT_PUBLIC_CRISP_WEBSITE_ID environment variable is not set');
}

const CrispChatWrapper = () => {
  return <CrispChat websiteId={CRISP_WEBSITE_ID} />;
};

export default CrispChatWrapper;
